import { eType, Section, SectionInitData } from "../Section";
import { GameWorld, eGameObject as eWorldObject } from "../../GameWorld";
import { Barrier, BarrierSettings } from "../../Barrier";
import { Character } from "../../../Player/Character";



export class BarrierInitData extends SectionInitData {
    /**
     * (RO) Nastaveni pro jednotlive zavory
     */
    get barriers(): BarrierSettings[] { return this._barriers; }
    private _barriers: BarrierSettings[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(sectionType: eType, barriers: BarrierSettings[]) {
        super(sectionType);
        this._barriers = barriers;
    }
}



export class Barrier_0 extends Section {
    private _barrier: Barrier;
    private _barrierSettings: BarrierSettings;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("barrier_0", eType.barrier_0, true);

        // Zavora
        this._barrier = new Barrier();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData?: SectionInitData): Section {
        this._barrierSettings = (<BarrierInitData>initData).barriers[0];

        super.activate(z, initData);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    deactivate(): Section {
        this._barrier.deactivate();
        return super.deactivate();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._barrier.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._barrier.update();
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @param plChar Overit kolize s postavou hrace
     */
    //-------------------------------------------------------------------------
    checkPlCollisions(plChar: Character): void {
        // Detekovat kolizi zavor s hracem
        this._barrier.checkPlCollision(plChar);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.safeArea_0);
        e.setLocalPosition(0, 0, 0);
        e.reparent(this._root);

        // Zavora
        this._barrier.activate(this._root, new pc.Vec3(-0.7, 0.04, 0), true, false, this._barrierSettings);
    }
}